/**
 * Notary Public — Q&A Wave 4 (hand-written, one unique answer per entry).
 *
 * ACCURACY POLICY (ตรวจ 2026-08-06)
 * - ไทยใช้ระบบ "ทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร" ตามข้อบังคับ
 *   สภาทนายความ — ไม่ใช่ Notary Public แบบ Common Law
 * - ค่าธรรมเนียมนิติกรณ์กรมการกงสุล 200 บาท/ตราประทับ (ปกติ)
 *   และ 400 บาท/ตราประทับ (ด่วน) — consular.mfa.go.th
 * - ไทยยังไม่ออก Apostille จนกว่าอนุสัญญาจะมีผล 28 ก.พ. 2027
 * - ห้ามระบุค่าบริการของเรา · ห้ามรับประกันผล การรับพิจารณาเป็นดุลพินิจ
 *   ของหน่วยงานปลายทางเสมอ
 */
import type { NotaryQA } from "./questions-500";

const NOTE =
  "ข้อมูล ณ ส.ค. 2026 — โปรดยืนยันรูปแบบที่ผู้รับเอกสารต้องการก่อนนัดลงนามทุกครั้ง";

export const NOTARY_QA_WAVE4: NotaryQA[] = [
  {
    slug: "notary-รับรองเอกสารสมัครเรียนต่างประเทศ",
    q: "เอกสารสมัครเรียนต่างประเทศต้องให้ทนายรับรองอะไรบ้าง?",
    aShort:
      "ที่พบบ่อยคือรับรองสำเนาถูกต้องของทรานสคริปต์และใบปริญญา รับรองลายมือชื่อผู้ปกครองในหนังสือรับรองการสนับสนุนค่าใช้จ่าย และรับรองคำแปลเอกสารการเงิน ส่วนสถาบันบางแห่งขอเอกสารส่งตรงจากมหาวิทยาลัยแทน",
    aLong:
      "ก่อนเดินเรื่อง ควรอ่านหน้า admissions requirements ให้ชัดว่าใช้คำว่า certified copy, notarised copy หรือ official transcript sent directly เพราะสามคำนี้ใช้เส้นทางต่างกัน หากเป็น notarised copy ต้องนำต้นฉบับมาแสดงต่อทนายเพื่อเทียบกับสำเนา และถ้าปลายทางขอ legalisation เพิ่ม ต้องส่งต่อกรมการกงสุลแล้วจึงถึงสถานทูตปลายทาง " +
      NOTE,
    synonyms: [
      "รับรองทรานสคริปต์ สมัครเรียนนอก",
      "notarised transcript thailand",
      "certified copy degree certificate thailand",
      "เอกสารการเงิน สมัครเรียน รับรอง",
    ],
    cluster: "documents",
  },
  {
    slug: "notary-หนังสือยินยอมให้บุตรเดินทาง",
    q: "หนังสือยินยอมให้บุตรเดินทางไปต่างประเทศต้องรับรองอย่างไร?",
    aShort:
      "ให้บิดามารดาลงนามต่อหน้าทนายผู้ทำคำรับรอง พร้อมแสดงบัตรประชาชนหรือหนังสือเดินทาง สูติบัตรของบุตร และหลักฐานความสัมพันธ์ หากปลายทางกำหนด ต้องผ่านนิติกรณ์และสถานทูตต่อ",
    aLong:
      "สายการบินและด่านตรวจคนเข้าเมืองหลายประเทศตรวจเอกสารนี้เข้มเมื่อเด็กเดินทางกับผู้ปกครองเพียงคนเดียวหรือเดินทางกับญาติ จุดที่ควรระบุให้ครบคือชื่อผู้พาเดินทาง ช่วงวันเดินทาง ประเทศปลายทาง และการให้ความยินยอมเรื่องการรักษาพยาบาลฉุกเฉิน กรณีมีคำสั่งศาลเรื่องอำนาจปกครอง ต้องแนบสำเนาคำสั่งพร้อมคำแปลด้วย " +
      NOTE,
    synonyms: [
      "หนังสือยินยอมให้บุตรเดินทาง",
      "parental consent letter travel thailand",
      "เด็กเดินทางคนเดียว เอกสาร",
      "child travel consent notary",
    ],
    cluster: "documents",
  },
  {
    slug: "notary-affidavit-สถานภาพโสด",
    q: "Affidavit รับรองสถานภาพโสดเพื่อจดทะเบียนสมรสต่างประเทศทำอย่างไร?",
    aShort:
      "ปกติเริ่มจากหนังสือรับรองสถานภาพจากที่ว่าการอำเภอหรือสำนักงานเขต แปลเป็นภาษาปลายทาง ผ่านนิติกรณ์กรมการกงสุล และบางกรณีให้ทนายรับรองคำสาบานประกอบตามรูปแบบที่ปลายทางกำหนด",
    aLong:
      "หลายประเทศเรียกเอกสารนี้ว่า certificate of no impediment หรือ single status affidavit ซึ่งบางแห่งรับเฉพาะฉบับที่ออกโดยหน่วยงานราชการ ไม่รับคำสาบานที่ทำต่อหน้าทนายเพียงอย่างเดียว จึงควรยืนยันกับสำนักทะเบียนปลายทางก่อนว่ารับรูปแบบใด แล้วจึงกำหนดลำดับงานเพื่อไม่ให้เอกสารเกินอายุที่ปลายทางกำหนด " +
      NOTE,
    synonyms: [
      "affidavit โสด",
      "certificate of no impediment thailand",
      "single status affidavit thai",
      "จดทะเบียนสมรสต่างประเทศ เอกสารโสด",
    ],
    cluster: "legal",
  },
  {
    slug: "notary-รับรองเอกสารบริษัทเปิดบัญชีต่างประเทศ",
    q: "เปิดบัญชีธนาคารหรือบริษัทลูกในต่างประเทศ ต้องรับรองเอกสารชุดไหน?",
    aShort:
      "ชุดมาตรฐานคือหนังสือรับรองบริษัท หนังสือบริคณห์สนธิ บัญชีรายชื่อผู้ถือหุ้น รายงานการประชุมกรรมการ และสำเนาหนังสือเดินทางกรรมการ ทั้งหมดรับรองสำเนาถูกต้อง แปล แล้วผ่านนิติกรณ์และสถานทูตปลายทางตามที่กำหนด",
    aLong:
      "ธนาคารต่างประเทศมักกำหนดอายุเอกสารบริษัทไม่เกินสามถึงหกเดือน และขอให้ผู้มีอำนาจลงนามลงชื่อต่อหน้าผู้รับรองพร้อมประทับตราบริษัท จุดที่ทำให้เสียเวลาคือดึงหนังสือรับรองมาก่อนแล้วจึงค่อยประชุมกรรมการ ทำให้วันที่ในรายงานการประชุมใหม่กว่าหนังสือรับรอง ควรจัดลำดับให้เอกสารทุกฉบับอยู่ในกรอบเวลาเดียวกัน " +
      NOTE,
    synonyms: [
      "รับรองเอกสารบริษัท เปิดบัญชีต่างประเทศ",
      "notarise company documents thailand",
      "corporate kyc documents legalisation",
      "หนังสือรับรองบริษัท แปล รับรอง",
    ],
    cluster: "documents",
  },
  {
    slug: "notary-รับรองลายมือชื่อออนไลน์ได้ไหม",
    q: "รับรองลายมือชื่อผ่านวิดีโอคอลได้หรือไม่?",
    aShort:
      "แนวปฏิบัติของไทยยังยึดการลงนามต่อหน้าผู้รับรองเป็นหลัก การประชุมทางไกลใช้เพื่อเตรียมเอกสารและตรวจร่างล่วงหน้าได้ แต่การลงนามจริงควรทำต่อหน้าเพื่อให้เอกสารเป็นที่ยอมรับของปลายทาง",
    aLong:
      "แม้บางประเทศจะมีระบบ remote online notarisation แต่ผู้รับเอกสารในสายงานราชการและธนาคารมักตรวจว่าผู้รับรองยืนยันตัวผู้ลงนามด้วยตนเองหรือไม่ วิธีลดการเดินทางคือส่งร่างเอกสารและสำเนาบัตรให้ตรวจล่วงหน้า นัดเวลาเข้าลงนามเพียงรอบเดียว และเตรียมเอกสารต่อเนื่องอย่างคำแปลไว้พร้อมในวันเดียวกัน " +
      NOTE,
    synonyms: [
      "notary ออนไลน์ ไทย",
      "remote online notarisation thailand",
      "รับรองเอกสาร ผ่าน zoom",
    ],
    cluster: "online",
  },
  {
    slug: "notary-เอกสารสองภาษาใช้ฉบับไหนบังคับ",
    q: "เอกสารสองภาษา ควรระบุอย่างไรว่าภาษาใดใช้บังคับ?",
    aShort:
      "ควรมีข้อสัญญาระบุชัดว่าเมื่อข้อความสองภาษาขัดกันให้ยึดฉบับภาษาใด และให้ข้อความนั้นปรากฏในทั้งสองภาษา เพื่อไม่ให้เกิดข้อโต้แย้งเมื่อยื่นต่อหน่วยงานหรือขึ้นสู่การพิจารณา",
    aLong:
      "ในทางปฏิบัติ ศาลไทยพิจารณาจากเอกสารภาษาไทยหรือคำแปลที่ยอมรับได้ ขณะที่คู่สัญญาต่างประเทศมักอ้างฉบับภาษาอังกฤษ การเขียนข้อกำหนดภาษาที่ใช้บังคับไว้ตั้งแต่ต้นจึงช่วยลดข้อพิพาท และควรให้ผู้แปลจัดหน้าแบบคอลัมน์คู่หรือย่อหน้าเทียบกัน เพื่อให้ผู้ตรวจสอบเทียบข้อความได้ทันที " +
      NOTE,
    synonyms: [
      "สัญญาสองภาษา ใช้ภาษาไหนบังคับ",
      "governing language clause thailand",
      "bilingual contract thai english",
    ],
    cluster: "legal",
  },
  {
    slug: "notary-ลำดับงานก่อนสถานทูต",
    q: "ลำดับที่ถูกต้องก่อนยื่นสถานทูตคืออะไร?",
    aShort:
      "ลำดับมาตรฐานคือ จัดทำหรือรับรองต้นฉบับ → แปลโดยผู้แปลที่ปลายทางยอมรับ → นิติกรณ์กรมการกงสุล → ยื่นสถานทูตปลายทาง ลำดับนี้สลับกันไม่ได้ เพราะแต่ละชั้นรับรองชั้นก่อนหน้า",
    aLong:
      "สาเหตุที่งานต้องทำใหม่บ่อยที่สุดคือแปลก่อนแล้วจึงแก้ต้นฉบับ หรือยื่นสถานทูตก่อนผ่านกรมการกงสุล ค่าธรรมเนียมนิติกรณ์กรมการกงสุลคือ 200 บาทต่อตราประทับสำหรับบริการปกติ และ 400 บาทต่อตราประทับสำหรับบริการด่วน ส่วนค่าธรรมเนียมสถานทูตแตกต่างกันไปในแต่ละประเทศและต้องตรวจกับสถานทูตนั้นโดยตรง " +
      NOTE,
    synonyms: [
      "ขั้นตอนรับรองเอกสารไปต่างประเทศ",
      "order of legalisation thailand",
      "แปล นิติกรณ์ สถานทูต ลำดับ",
    ],
    cluster: "embassy",
  },
  {
    slug: "notary-รับรองสำเนาพาสปอร์ต",
    q: "รับรองสำเนาหนังสือเดินทางต้องเตรียมอะไร?",
    aShort:
      "ต้องนำหนังสือเดินทางเล่มจริงมาแสดงต่อทนายผู้ทำคำรับรอง พร้อมสำเนาหน้าข้อมูลส่วนบุคคลที่ชัดเจน ผู้รับรองจะเทียบต้นฉบับกับสำเนาแล้วลงนามรับรองว่าเป็นสำเนาที่ถูกต้อง",
    aLong:
      "ธนาคารและหน่วยงานต่างประเทศบางแห่งกำหนดข้อความรับรองแบบเฉพาะ เช่น ต้องมีคำว่า true copy of the original seen by me พร้อมวันที่และรายละเอียดผู้รับรอง ควรขอตัวอย่างข้อความจากผู้รับเอกสารก่อน หากต้องใช้หลายฉบับ ให้แจ้งจำนวนตั้งแต่ต้นเพื่อรับรองในคราวเดียว " +
      NOTE,
    synonyms: [
      "รับรองสำเนาพาสปอร์ต",
      "certified true copy passport thailand",
      "notarise passport copy bangkok",
    ],
    cluster: "documents",
  },
  {
    slug: "notary-สาเหตุเอกสารถูกตีกลับ",
    q: "เอกสารที่ผ่านการรับรองแล้วยังถูกตีกลับเพราะอะไร?",
    aShort:
      "สาเหตุที่พบบ่อยคือใช้แบบฟอร์มไม่ตรงกับที่ปลายทางกำหนด ข้อความรับรองไม่ครบตามที่ผู้รับเอกสารระบุ ชื่อสะกดไม่ตรงหนังสือเดินทาง ขาดชั้นนิติกรณ์หรือตราสถานทูต และเอกสารเกินอายุที่ปลายทางกำหนด",
    aLong:
      "แนวทางป้องกันคือขอเช็กลิสต์เป็นลายลักษณ์อักษรจากผู้รับเอกสาร ตรวจสี่ประเด็นก่อนเริ่มงาน ได้แก่ แบบฟอร์ม ข้อความรับรอง ชั้นการรับรอง และอายุเอกสาร จากนั้นถ่ายภาพเอกสารทุกชั้นเก็บไว้ หากถูกสอบถามภายหลังจะชี้แจงได้เร็วและไม่ต้องเริ่มกระบวนการใหม่ทั้งชุด " +
      NOTE,
    synonyms: [
      "เอกสารรับรองถูกปฏิเสธ",
      "document rejected embassy thailand",
      "notarised document not accepted",
    ],
    cluster: "process",
  },
  {
    slug: "notary-apostille-2027-ต้องเตรียมอะไร",
    q: "ก่อน Apostille มีผลกับไทยในปี 2027 ควรวางแผนเอกสารอย่างไร?",
    aShort:
      "อนุสัญญามีผลกับไทยวันที่ 28 กุมภาพันธ์ 2027 งานที่ต้องยื่นก่อนวันดังกล่าวยังใช้เส้นทางนิติกรณ์และตราสถานทูตตามปกติ ส่วนงานที่ยื่นหลังจากนั้นควรรอแนวปฏิบัติที่หน่วยงานประกาศ",
    aLong:
      "สำหรับองค์กรที่ต้องรับรองเอกสารชุดใหญ่เป็นประจำ แนวทางที่คุ้มที่สุดคือแยกงานเร่งด่วนออกมาทำตามเส้นทางปัจจุบัน และเลื่อนงานที่ยังไม่มีกำหนดยื่นไปไว้หลังวันที่อนุสัญญามีผล เพื่อลดจำนวนตราประทับที่ต้องขอ ทั้งนี้ต้องยืนยันกับผู้รับเอกสารในต่างประเทศว่ารับตรา Apostille ของไทยตั้งแต่วันใด " +
      NOTE,
    synonyms: [
      "apostille ไทย 2027",
      "thailand apostille effective date",
      "เตรียมเอกสารก่อน apostille",
    ],
    cluster: "apostille",
  },
  {
    slug: "notary-รับรองเอกสารผู้สูงอายุติดเตียง",
    q: "ผู้ลงนามป่วยหรือเดินทางไม่ได้ จะรับรองเอกสารอย่างไร?",
    aShort:
      "สามารถนัดให้ผู้รับรองเดินทางไปพบผู้ลงนามที่บ้านหรือโรงพยาบาลได้ โดยผู้ลงนามต้องมีสติสัมปชัญญะและแสดงเจตนาได้ด้วยตนเอง พร้อมบัตรประจำตัวที่ยังไม่หมดอายุ",
    aLong:
      "กรณีเอกสารสำคัญอย่างหนังสือมอบอำนาจจัดการทรัพย์สินหรือพินัยกรรม ควรมีพยานและบันทึกรายละเอียดสถานที่ วันเวลา และผู้ร่วมอยู่ในเหตุการณ์ เพื่อลดข้อโต้แย้งภายหลัง หากผู้ลงนามไม่สามารถแสดงเจตนาได้แล้ว การรับรองลายมือชื่อทำไม่ได้ ต้องพิจารณาช่องทางตามกฎหมายเรื่องผู้อนุบาลหรือผู้พิทักษ์แทน " +
      NOTE,
    synonyms: [
      "รับรองเอกสารนอกสถานที่",
      "mobile notary bangkok hospital",
      "ผู้ป่วยลงนามมอบอำนาจ",
    ],
    cluster: "location",
  },
  {
    slug: "notary-เอกสารต่างประเทศนำมาใช้ในไทย",
    q: "เอกสารที่รับรองจากต่างประเทศ นำมาใช้ในไทยต้องทำอะไรเพิ่ม?",
    aShort:
      "โดยทั่วไปต้องผ่านการรับรองในประเทศต้นทางจนถึงสถานเอกอัครราชทูตหรือสถานกงสุลไทยในประเทศนั้น แล้วนำเข้ามาแปลเป็นภาษาไทยและยื่นนิติกรณ์ที่กรมการกงสุลอีกชั้นตามที่หน่วยงานผู้รับกำหนด",
    aLong:
      "หน่วยงานไทยที่ตรวจเอกสารต่างประเทศเข้มที่สุดคือสำนักงานที่ดิน สำนักทะเบียน และศาล เพราะเกี่ยวข้องกับสิทธิในทรัพย์สินและสถานะบุคคล ควรถามหน่วยงานผู้รับก่อนว่าต้องการคำแปลโดยผู้แปลรูปแบบใด และต้องมีตราของสถานทูตไทยหรือไม่ เพื่อไม่ให้ต้องส่งเอกสารกลับไปรับรองใหม่ที่ต้นทาง " +
      NOTE,
    synonyms: [
      "เอกสารต่างประเทศ ใช้ในไทย",
      "foreign document use in thailand legalisation",
      "รับรองเอกสารจากสถานทูตไทย",
    ],
    cluster: "legal",
  },
];
